
import { ModalForm } from 'components/ModalForm/ModalForm'
import { useEffect, useRef, useState } from 'react'
import { trans } from 'utils/helpers'
import './style.scss'
import { Button } from 'components/Button/Button'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MessageType } from 'types/enum'
import { Toast } from "components/ToastShow/ToastAlert";

export const Help = ({modalWidth}) => {
    
    const [show, setShow] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [com, setCom] = useState("");
    const [editMode,setEditMode]=useState(false)
    const formRef=useRef<any>()
    const [Storage, setStorage] = useState<any>(JSON.parse(localStorage.Shortcut));
    function showModal(e) {
        setCom(e);
        setShow(true);
    }
    
    const breakPoint = modalWidth


    
    const storageLengthDividedByTwo= Math.ceil(Object.keys(Storage).length / 2)
    const dataArr1 = Object.keys(Storage).slice(0, storageLengthDividedByTwo)
    const [value,setValue]=useState<any>()
    const dataArr2 = Object.keys(Storage).slice(storageLengthDividedByTwo)
    const halfStorageDataArray =breakPoint?Object.keys(JSON.parse(localStorage.Shortcut)): [dataArr1, dataArr2]    

    
    window.onresize = () => {
      setWidth(window.innerWidth)
    }
    
    

const handleSubmit=()=>{
    let data={}
    // conventionalItem=
    if(breakPoint){
halfStorageDataArray.forEach((item)=>{

    data[item]=formRef.current?.[item]?.value
;
    
})
    }else{
    
        
[...halfStorageDataArray[0] as any,...halfStorageDataArray[1] as any].forEach((item)=>{
    data[item]=formRef.current?.[item]?.value
    

    
})
    }


const hasDuplicates = new Set(Object.values(data))?.size !==  Object.values(data)?.length;


if(hasDuplicates){
Toast(trans("duplicatekey").replace('{0}',''),MessageType.error)
}else{
 localStorage.setItem('Shortcut',JSON.stringify(data))

}
}

    function set(event) {
        if(event.code!="Backspace"){
        event.preventDefault();
        event.stopPropagation()
 let shortcut = '';
        if (event.ctrlKey) {
            shortcut += 'ctrl +';
        }
        else if (event.altKey) {
            shortcut += 'alt +';
        }
        else if (event.shiftKey) {
            shortcut += 'shift +';
        }
        if(event.key == "Delete"){
            shortcut = shortcut + " Del" ;
        }else{
          if(shortcut.includes('+') || shortcut.includes('Del') ){
            shortcut = shortcut + " " + event.key;           
          }else{
             shortcut = event.key;   
          }
        }
       setValue({...value,[event.target.name]:shortcut})
}else{
       setValue({...value,[event.target.name]:''})
}
   
        }
    return ( 
    <div className='card w-100'>
         <div className="col-12 d-flex justify-content-end">
<div className='ms-2 mt-2 '>
          { !editMode? <OverlayTrigger
                      key={"edit"}
                      placement="top"
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"reserve"}`}
                        >
                          {trans("edit")}
                        </Tooltip>
                      }
                    >
                      <button
                        name="edit"
                        onClick={(e) => {
                          setEditMode(true)
                        }}
                        className="btn btn-sm ms-1 btn-primary d-flex justify-content-center align-items-center customBtnSize p-1"
                      >
                        <FontAwesomeIcon
                          style={{ fontSize: "12px" }}
                          color={"white"}
                          icon={["fas", "edit"]}
                        />
                      </button>
                    </OverlayTrigger>:
                    
                <OverlayTrigger
                      key={"edit"}
                      placement="top"
                      delay={{ show: 600, hide: 0 }}
                      overlay={
                        <Tooltip
                          className="tooltip "
                          id={`button-tooltip-${"reserve"}`}
                        >
                          {trans("save")}
                        </Tooltip>
                      }
                    >
                      <button
                        name="edit"
                        onClick={(e) => {
                          setEditMode(false)
                          handleSubmit()
                        }}
                        className="btn btn-sm ms-1 btn-success d-flex justify-content-center align-items-center customBtnSize p-1"
                      >
                        <FontAwesomeIcon
                          style={{ fontSize: "12px" }}
                          color={"white"}
                          icon={["fas", "check"]}
                        />
                      </button>
                    </OverlayTrigger>
                
                }
</div>

         </div>
            <div className='d-flex w-100'>          
                {breakPoint ? (
                    <form action="" ref={formRef}  className='w-100 mx-4'>
                    
                        <div className='help__header d-flex mx-auto'>
                            <h6>دستور</h6>
                            <h6>کلید</h6>
                        </div>
                        {halfStorageDataArray.map(data => (
                            <div  className='help__item mx-auto'>
                                <p className='command'>{(data)}</p>
                                <input name={data} value={value?.[data]} defaultValue={value?.[data]?value?.[data]:Storage[data]} onKeyDown={set} disabled={!editMode} style={{textAlign:'center'}}/>
           
                            </div>
                        ))}
                   
                    </form>
                    ):
                <form ref={formRef} action="" className='d-flex w-100' >


{

     halfStorageDataArray.map(item => (
                      
                       <div className='w-100 mx-4'>
                            <div className='help__header d-flex mx-auto'>
                                <h6>دستور</h6>
                                <h6>کلید</h6>
                            </div>
                          
                            {item.map(data => (
                                <div  className='help__item mx-auto'>
                                <p className='command'>{trans(data)}</p>
                                <div className="d-flex ">
                                <input name={data} value={value?.[data]} defaultValue={value?.[data]?value?.[data]:Storage[data]} onKeyDown={set} disabled={!editMode} style={{textAlign:'center'}}/>

     
                                </div>
                       
                                </div>
                            ))}
                       
                     </div>
                    ))

}
                
                 </form>
                }
        
              
            </div>
        </div>
    )
}